@if (isOpen()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 py-4">
    <div
      class="w-full max-w-md max-h-[85vh] overflow-y-auto rounded-[2rem] bg-[#fcfaf7] shadow-xl animate-in fade-in zoom-in-95 duration-200"
    >
      <div class="px-5 pt-5 pb-3 border-b border-black/5">
        <h3 class="text-lg font-semibold text-[#1f1b16]">
          {{ itemDescription() }}
        </h3>
        <p class="mt-1 text-sm text-[#3a332c]/60">
          Indicá cómo querés ayudar a representar este consumo.
        </p>
      </div>

      <div class="px-5 py-4 space-y-4">
        <div class="space-y-3">
          <button
            type="button"
            (click)="setMode('HOST_RESOLVE')"
            class="w-full rounded-2xl px-4 py-4 text-left transition border"
            [class.border-orange-300]="selectedMode() === 'HOST_RESOLVE'"
            [class.bg-orange-50]="selectedMode() === 'HOST_RESOLVE'"
            [class.border-transparent]="selectedMode() !== 'HOST_RESOLVE'"
            [class.bg-white]="selectedMode() !== 'HOST_RESOLVE'"
          >
            <p class="text-sm font-semibold text-[#1f1b16]">Dejar que el anfitrión lo resuelva</p>
            <p class="mt-1 text-xs text-[#3a332c]/60">Podés solo marcar que consumiste el item</p>
          </button>

          <button
            type="button"
            (click)="setMode('SUGGEST_GROUPS')"
            class="w-full rounded-2xl px-4 py-4 text-left transition border"
            [class.border-orange-300]="selectedMode() === 'SUGGEST_GROUPS'"
            [class.bg-orange-50]="selectedMode() === 'SUGGEST_GROUPS'"
            [class.border-transparent]="selectedMode() !== 'SUGGEST_GROUPS'"
            [class.bg-white]="selectedMode() !== 'SUGGEST_GROUPS'"
          >
            <p class="text-sm font-semibold text-[#1f1b16]">
              Sugerir separar el total de items en grupos
            </p>
            <p class="mt-1 text-xs text-[#3a332c]/60">
              Podés sugerir hasta dos grupos para orientar al anfitrión.
            </p>
          </button>
        </div>

        @if (selectedMode() === 'SUGGEST_GROUPS') {
          <div class="rounded-2xl bg-white px-4 py-4 shadow-sm space-y-4">
            <div class="flex items-center justify-between">
              <h4 class="text-sm font-semibold text-[#1f1b16]">Grupos sugeridos</h4>

              <span class="text-xs text-[#3a332c]/60">
                Restan {{ remainingQuantity() }} ítems
              </span>
            </div>

            <div class="space-y-3">
              @for (group of localGroups(); track group.localId) {
                <div class="rounded-2xl bg-[#f6f1eb] px-3 py-3 space-y-3">
                  <div class="flex items-center justify-between">
                    <span class="text-sm font-medium text-[#1f1b16]"> Grupo </span>

                    @if (groupsCount() > 1) {
                      <button
                        type="button"
                        (click)="removeGroup(group.localId)"
                        class="text-xs font-medium text-red-500"
                      >
                        Quitar
                      </button>
                    }
                  </div>

                  <div class="flex items-center justify-center gap-4">
                    <button
                      type="button"
                      (click)="decrementSize(group.localId)"
                      class="h-10 w-10 rounded-full bg-white text-xl font-semibold shadow-sm"
                    >
                      -
                    </button>

                    <div class="text-center min-w-[48px]">
                      <p class="text-2xl font-semibold">{{ group.size }}</p>
                    </div>

                    <button
                      type="button"
                      (click)="incrementSize(group.localId)"
                      class="h-10 w-10 rounded-full bg-white text-xl font-semibold shadow-sm"
                    >
                      +
                    </button>
                  </div>

                  <div class="grid grid-cols-2 gap-2">
                    <button
                      type="button"
                      (click)="setParticipation(group.localId, 'INDIVIDUAL')"
                      class="rounded-xl py-2 text-sm font-medium transition"
                      [class.bg-orange-500]="group.participation === 'INDIVIDUAL'"
                      [class.text-white]="group.participation === 'INDIVIDUAL'"
                      [class.bg-white]="group.participation !== 'INDIVIDUAL'"
                      [class.text-[#3a332c]/70]="group.participation !== 'INDIVIDUAL'"
                    >
                      Lo consumí solo
                    </button>

                    <button
                      type="button"
                      (click)="setParticipation(group.localId, 'SHARED')"
                      class="rounded-xl py-2 text-sm font-medium transition"
                      [class.bg-orange-500]="group.participation === 'SHARED'"
                      [class.text-white]="group.participation === 'SHARED'"
                      [class.bg-white]="group.participation !== 'SHARED'"
                      [class.text-[#3a332c]/70]="group.participation !== 'SHARED'"
                    >
                      Lo compartí
                    </button>
                  </div>
                </div>
              }
            </div>

            @if (canAddGroup()) {
              <button
                type="button"
                (click)="addGroup()"
                class="w-full rounded-xl border border-dashed border-orange-300 px-4 py-3 text-sm font-medium text-orange-600"
              >
                + Agregar otro grupo
              </button>
            }
          </div>
        }
      </div>

      <div class="px-5 pb-5 pt-2 flex gap-3">
        <button
          type="button"
          (click)="canceled.emit()"
          class="flex-1 rounded-2xl bg-white py-3 text-sm font-medium text-[#3a332c]/70 shadow-sm"
        >
          Cancelar
        </button>

        <button
          type="button"
          (click)="onConfirm()"
          [disabled]="!canConfirm()"
          class="flex-[1.2] rounded-2xl py-3 text-sm font-semibold transition"
          [class.bg-gradient-to-r]="canConfirm()"
          [class.from-orange-500]="canConfirm()"
          [class.to-amber-500]="canConfirm()"
          [class.text-white]="canConfirm()"
          [class.bg-[#e7ded4]]="!canConfirm()"
          [class.text-[#3a332c]/40]="!canConfirm()"
        >
          Guardar sugerencia
        </button>
      </div>
    </div>
  </div>
}
